import { useReducer } from "react"

export const useRerender = (): [rerenderId: number, rerender: () => void] => {
  return useReducer((id: number) => id + 1, 0)
}
